import { createFileRoute } from '@tanstack/react-router';

import { CustomerOfferPage } from '../../components/CustomerOfferPage';

export const Route = createFileRoute('/customer/$token')({
  component: CustomerOfferPage,
});
